import {
  OracleIcon
} from "./chunk-BKIWCWWA.mjs";
export {
  OracleIcon
};
